import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {useMutation, useLazyQuery } from '@apollo/react-hooks';
import Alert from 'react-bootstrap/Alert';
import {ValidatorUtil} from '@aperza/validator';
import SurveyPage from './SurveyPage';
import {Button, Message} from '@aperza/ui';
import FormFieldUtil from "../../util/FormFieldUtil";
import SurveyComment from './SurveyComment';

import SurveyUserInfo from './SurveyUserInfo';

const SUBMIT_SURVEY = gql`
    mutation SubmitSurveyMutation($input: SubmitSurveyInput!) {
        submitSurvey(input: $input) {
            clientMutationId
            response {
                submitted
                downloadUrl
            }
        }
    }
`;

const REFRESH_VIEWER = gql`
    query RefreshViewerQuery {
        viewer {
            id
            userId
            isLogin
            isInternalUser
            cluezUser {
                id
                locale
                addressLargeAreaId
                statusCode
                countryCode
            }
        }
    }
`;

const Survey = (props) => {

  let {
    leadType,
    relatedIds = [],
    viewer = {},
    showUserInfo = false,
    afterSubmitSurvey,
  } = props;

  let {
    leadSurvey = {},
  } = viewer;

  if (leadSurvey == null) leadSurvey = {};

  let {
    title,
    pages = [],
  } = leadSurvey;

  //TODO limited to 2 survey pages. Find a way to expand this
  //Alternative to send random validation request id.
  let ref0 = useRef(null);
  let ref1 = useRef(null);

  let pageRefs = [ref0, ref1];
  let userInfoRef = useRef(null);

  let [step, setStep] = useState(1);
  let [errorId, setErrorId] = useState(undefined);
  let [readOnly, setReadOnly] = useState(false);

  const onCompletedSubmit = (data) => {
    if (afterSubmitSurvey) {
      afterSubmitSurvey(data.submitSurvey);
    }
    // if (data && data.submitSurvey && data.submitSurvey.response) {
    //   let response = data.submitSurvey.response;
    //   if (response.catalogDownload) {
    //     console.log('VITO onCompletedSubmit downloadUrl', response.catalogDownload.downloadUrl);
    //     //document.getElementById('catalog-download-file-form').setAttribute('src', response.catalogDownload.downloadUrl);
    //     document.getElementById('catalog-download-file-form').setAttribute('href', response.catalogDownload.downloadUrl);
    //     document.getElementById('catalog-download-file-form').setAttribute('download', 'test.pdf');
    //     document.getElementById('catalog-download-file-form').click();
    //   }
    // }
  };

  const onErrorSubmit = (error) => {
    console.log('onErrorSubmit', error);
    //setErrorId(ErrorUtil.parseApolloError(error));
  };

  const onErrorRefresh = (error) => {
    console.log('onErrorRefresh', error);
    //setErrorId(ErrorUtil.parseApolloError(error));
  };

  const [refreshViewer, { called, data }] = useLazyQuery(
    REFRESH_VIEWER,
    {
      onError: onErrorRefresh,
      fetchPolicy: 'network-only',
    }
  );

  const [submitSurvey, {loading}] = useMutation(SUBMIT_SURVEY, {
    onCompleted: onCompletedSubmit,
    onError: onErrorSubmit,
  });

  const onSubmitSurvey = (fields = [], userInfoFields = {}) => {
    let answers = [];
    let comment = undefined;
    fields.forEach(field => {
      let fieldId = field.fieldId;
      if (fieldId === 'field_comment') {
        comment = field.value;
        return;
      }
      let value = field.value;
      if (Array.isArray(value)) {
        value.forEach(v => {
          answers.push({
            id: fieldId,
            answerId: +v,
          })
        })
      } else {
        answers.push({
          id: fieldId,
          answerId: +value,
        })
      }
    });

    let data = {
      leadType: leadType,
      relatedIds: relatedIds,
      answer: {
        id: +leadSurvey.plainId,
        answers: answers,
      },
      inquiryContents: comment,
    };

    if (leadType === 'DOWNLOAD_CATALOG') {
      data.catalogDownloadPage = {
        pageType: 'DOWNLOAD',
        pageId: '',
      }
    }

    if (showUserInfo) {
      let aperzaUser = {};
      console.log('userInfoFields', userInfoFields);
      Object.keys(userInfoFields).forEach(key => {
        let field = userInfoFields[key];
        let fieldId = field.fieldName;
        let value = field.value;
        aperzaUser[fieldId] = value;
      });
      console.log('aperzaUser', aperzaUser);
      data.aperzaUser = aperzaUser;
    }

    return submitSurvey({
      variables: {
        input: data
      }
    });
  };

  const validateSurveyPages = () => {
    let hasError = false;
    pageRefs.forEach(pageRef => {
      if (pageRef.current) {
        let updatedFields = pageRef.current.validate();
        if (FormFieldUtil.hasError(updatedFields) && !hasError) {
          hasError = true;
        }
      }
    });
    return hasError;
  };

  const validateSurveyUserInfo = () => {
    if (!showUserInfo) return true; //Return true if the Survey User Info is not shown
    let hasError = false;
    if (userInfoRef.current) {
      let updatedFields = userInfoRef.current.validate();
      if (ValidatorUtil.hasError(updatedFields) && !hasError) {
        hasError = true;
      }
    }
    return hasError;
  };

  const onSubmit = () => {
    if (step === 1) {
      let hasError = validateSurveyPages();
      let hasErrorUserInfo = validateSurveyUserInfo();
      if (!hasError && !hasErrorUserInfo) {
        setReadOnly(true);
        setStep(2);
      }
    } else if (step === 2) {
      if (pageRefs.length) {
        let pageRef = pageRefs[0];
        if (pageRef.current) {
          let updatedFields = pageRef.current.validate();

          let userInfoUpdatedFields;
          if (showUserInfo && userInfoRef.current) {
            userInfoUpdatedFields = userInfoRef.current.validate();
          }

          onSubmitSurvey(updatedFields, userInfoUpdatedFields);
        }
      }
    }

  };

  const goToStep1 = () => {
    console.log('goToStep1');
    setReadOnly(false);
    setStep(1);
  };

  const onLogin = async () => {
    await refreshViewer();
  };

  const onUpdateSurveyUserInfoFieldMap = (fieldMap) => {
    let hasError = validateSurveyPages();
    if (!hasError) {
      setReadOnly(true);
    }
  };

  return (
    <div className={'aw-form'}>
      <h3>{title}</h3>
      {errorId && (
        <Alert variant={'danger'}>
          <Message messageId={errorId}/>
        </Alert>
      )}
      {pages.map((page, index) => {
        return (
          <SurveyPage key={index}
                      ref={pageRefs[index]}
                      readOnly={readOnly}
                      loading={loading}
                      surveyPage={page}
                      enableComment={true}
                      onSubmit={onSubmit}/>
        )
      })}
      {showUserInfo &&
      <SurveyUserInfo ref={userInfoRef} viewer={viewer} readOnly={readOnly} onLogin={onLogin}/>
      }
      <div className={'mt-3 d-flex justify-content-center align-items-center'}>
        {step == 1 &&
        <Button id={'survey-button-confirm'} size="xxl" loading={loading} type={Button.TYPE_PRIMARY} onClick={onSubmit} disabled={(showUserInfo && (viewer && !viewer.isLogin))} >
          <Message messageId={'inputContentConfirm'}/>
        </Button>
        }
        {step == 2 &&
        <>
          <div className={'mr-1'}>
            <Button id={'survey-button-back'} size="xxl" type={Button.TYPE_SECONDARY} disabled={loading} onClick={goToStep1}><Message
              messageId={'back'}/></Button>
          </div>
          <div className={'ml-1'}>
            <Button id={'survey-button-submit'} size="xxl" type={Button.TYPE_PRIMARY} loading={loading}
                    onClick={onSubmit}><Message
              messageId={'completeButton'}/></Button>
          </div>
        </>
        }
      </div>
    </div>
  );

};

Survey.fragments = {
  viewer: gql`
      fragment Survey_viewer on Viewer
      {
          isLogin
          leadSurvey(leadType: $leadType) {
              id
              plainId
              title
              description
              pages {
                  id
                  ...SurveyPage_surveyPage
              }
          }
          ...SurveyUserInfo_viewer

      }
      ${SurveyPage.fragments.surveyPage}
      ${SurveyUserInfo.fragments.viewer}
  `
};

Survey.propTypes = {
  leadType: PropTypes.string.isRequired,
  relatedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  viewer: PropTypes.any,
  showUserInfo: PropTypes.bool,
  afterSubmitSurvey: PropTypes.func,
};

export default Survey;
